import { useMemo } from 'react';
import { useDispatch } from 'react-redux';

/**
 * Experimental.
 * The idea is be able to call an API and get a Promise directly
 * instead of having the response pipe through Redux and then having to
 * pull the result out of Redux state.
 * The `apiClient` is added a parameter to Redux thunks.
 * We are using the thunk just to access the `apiClient`.
 * This code is a little awkward.
 * We could consider putting the apiClient in the Redux state and then selecting it out.
 */

const useApiClient = () => {
  const dispatch = useDispatch();
  return useMemo(() => {
    return dispatch((_dispatch, _getState, apiClientInstace) => apiClientInstace);
  }, [dispatch]);
};

export default useApiClient;
